{
  "name": "github-dark",
  "colors": {
    "focusBorder": "#005cc5",
    "foreground": "#d1d5da",
    "descriptionForeground": "#959da5",
    "errorForeground": "#f97583",
    "textLink.foreground": "#79b8ff",
    "textLink.activeForeground": "#c8e1ff",
    "textBlockQuote.background": "#24292e",
    "textBlockQuote.border": "#444d56",
    "textCodeBlock.background": "#2f363d",
    "textPreformat.foreground": "#d1d5da",
    "textSeparator.foreground": "#586069",
    "button.background": "#176f2c",
    "button.foreground": "#dcffe4",
    "button.hoverBackground": "#22863a",
    "button.secondaryBackground": "#444d56",
    "button.secondaryForeground": "#fff",
    "button.secondaryHoverBackground": "#586069",
    "checkbox.background": "#444d56",
    "checkbox.border": "#1b1f23",
    "dropdown.background": "#2f363d",
    "dropdown.border": "#1b1f23",
    "dropdown.foreground": "#e1e4e8",
    "dropdown.listBackground": "#24292e",
    "input.background": "#2f363d",
    "input.border": "#1b1f23",
    "input.foreground": "#e1e4e8",
    "input.placeholderForeground": "#959da5",
    "badge.foreground": "#c8e1ff",
    "badge.background": "#044289",
    "progressBar.background": "#0366d6",
    "titleBar.activeForeground": "#e1e4e8",
    "titleBar.activeBackground": "#24292e",
    "titleBar.inactiveForeground": "#959da5",
    "titleBar.inactiveBackground": "#1f2428",
    "titleBar.border": "#1b1f23",
    "activityBar.foreground": "#e1e4e8",
    "activityBar.inactiveForeground": "#6a737d",
    "activityBar.background": "#24292e",
    "activityBarBadge.foreground": "#fff",
    "activityBarBadge.background": "#0366d6",
    "activityBar.activeBorder": "#f9826c",
    "activityBar.border": "#1b1f23",
    "sideBar.foreground": "#d1d5da",
    "sideBar.background": "#1f2428",
    "sideBar.border": "#1b1f23",
    "sideBarTitle.foreground": "#e1e4e8",
    "sideBarSectionHeader.foreground": "#e1e4e8",
    "sideBarSectionHeader.background": "#1f2428",
    "sideBarSectionHeader.border": "#1b1f23",
    "list.hoverForeground": "#e1e4e8",
    "list.inactiveSelectionForeground": "#e1e4e8",
    "list.activeSelectionForeground": "#e1e4e8",
    "list.hoverBackground": "#282e34",
    "list.inactiveSelectionBackground": "#282e34",
    "list.activeSelectionBackground": "#39414a",
    "list.inactiveFocusBackground": "#1d2d3e",
    "list.focusBackground": "#044289",
    "tree.indentGuidesStroke": "#2f363d",
    "notificationCenterHeader.foreground": "#959da5",
    "notificationCenterHeader.background": "#24292e",
    "notifications.foreground": "#e1e4e8",
    "notifications.background": "#2f363d",
    "notifications.border": "#1b1f23",
    "notificationsErrorIcon.foreground": "#ea4a5a",
    "notificationsWarningIcon.foreground": "#ffab70",
    "notificationsInfoIcon.foreground": "#79b8ff",
    "pickerGroup.border": "#444d56",
    "pickerGroup.foreground": "#e1e4e8",
    "quickInput.background": "#24292e",
    "quickInput.foreground": "#e1e4e8",
    "statusBar.foreground": "#d1d5da",
    "statusBar.background": "#24292e",
    "statusBar.border": "#1b1f23",
    "statusBar.noFolderBackground": "#24292e",
    "statusBar.debuggingBackground": "#931c06",
    "statusBar.debuggingForeground": "#fff",
    "statusBarItem.prominentBackground": "#282e34",
    "statusBarItem.remoteForeground": "#d1d5da",
    "statusBarItem.remoteBackground": "#24292e",
    "editorGroupHeader.tabsBackground": "#1f2428",
    "editorGroupHeader.tabsBorder": "#1b1f23",
    "editorGroup.border": "#1b1f23",
    "tab.activeForeground": "#e1e4e8",
    "tab.inactiveForeground": "#959da5",
    "tab.inactiveBackground": "#1f2428",
    "tab.activeBackground": "#24292e",
    "tab.hoverBackground": "#24292e",
    "tab.unfocusedHoverBackground": "#24292e",
    "tab.border": "#1b1f23",
    "tab.unfocusedActiveBorderTop": "#1b1f23",
    "tab.activeBorder": "#24292e",
    "tab.unfocusedActiveBorder": "#24292e",
    "tab.activeBorderTop": "#f9826c",
    "breadcrumb.foreground": "#959da5",
    "breadcrumb.focusForeground": "#e1e4e8",
    "breadcrumb.activeSelectionForeground": "#d1d5da",
    "breadcrumbPicker.background": "#2b3036",
    "editor.foreground": "#e1e4e8",
    "editor.background": "#24292e",
    "editorWidget.background": "#1f2428",
    "editor.foldBackground": "#58606915",
    "editor.lineHighlightBackground": "#2b3036",
    "editorLineNumber.foreground": "#444d56",
    "editorLineNumber.activeForeground": "#e1e4e8",
    "editorIndentGuide.background": "#2f363d",
    "editorIndentGuide.activeBackground": "#444d56",
    "editorWhitespace.foreground": "#444d56",
    "editorCursor.foreground": "#c8e1ff",
    "editorError.foreground": "#f97583",
    "editorWarning.foreground": "#ffea7f",
    "editor.findMatchBackground": "#ffd33d44",
    "editor.findMatchHighlightBackground": "#ffd33d22",
    "editor.linkedEditingBackground": "#3392FF22",
    "editor.inactiveSelectionBackground": "#3392FF22",
    "editor.selectionBackground": "#3392FF44",
    "editor.selectionHighlightBackground": "#17E5E633",
    "editor.selectionHighlightBorder": "#17E5E600",
    "editor.wordHighlightBackground": "#17E5E600",
    "editor.wordHighlightStrongBackground": "#17E5E600",
    "editor.wordHighlightBorder": "#17E5E699",
    "editor.wordHighlightStrongBorder": "#17E5E666",
    "editorBracketMatch.background": "#17E5E650",
    "editorBracketMatch.border": "#17E5E600",
    "editorGutter.modifiedBackground": "#2188ff",
    "editorGutter.addedBackground": "#28a745",
    "editorGutter.deletedBackground": "#ea4a5a",
    "diffEditor.insertedTextBackground": "#28a74530",
    "diffEditor.removedTextBackground": "#d73a4930",
    "scrollbar.shadow": "#0008",
    "scrollbarSlider.background": "#6a737d33",
    "scrollbarSlider.hoverBackground": "#6a737d44",
    "scrollbarSlider.activeBackground": "#6a737d88",
    "editorOverviewRuler.border": "#1b1f23",
    "panel.background": "#1f2428",
    "panel.border": "#1b1f23",
    "panelTitle.activeBorder": "#f9826c",
    "panelTitle.activeForeground": "#e1e4e8",
    "panelTitle.inactiveForeground": "#959da5",
    "panelInput.border": "#2f363d",
    "terminal.foreground": "#d1d5da",
    "terminal.tab.activeBorder": "#f9826c",
    "terminalCursor.background": "#586069",
    "terminalCursor.foreground": "#79b8ff",
    "terminal.ansiBrightWhite": "#fafbfc",
    "terminal.ansiWhite": "#d1d5da",
    "terminal.ansiBrightBlack": "#959da5",
    "terminal.ansiBlack": "#586069",
    "terminal.ansiBlue": "#2188ff",
    "terminal.ansiBrightBlue": "#79b8ff",
    "terminal.ansiGreen": "#34d058",
    "terminal.ansiBrightGreen": "#85e89d",
    "terminal.ansiCyan": "#39c5cf",
    "terminal.ansiBrightCyan": "#56d4dd",
    "terminal.ansiRed": "#ea4a5a",
    "terminal.ansiBrightRed": "#f97583",
    "terminal.ansiMagenta": "#b392f0",
    "terminal.ansiBrightMagenta": "#b392f0",
    "terminal.ansiYellow": "#ffea7f",
    "terminal.ansiBrightYellow": "#ffea7f",
    "editorBracketHighlight.foreground1": "#79b8ff",
    "editorBracketHighlight.foreground2": "#ffab70",
    "editorBracketHighlight.foreground3": "#b392f0",
    "editorBracketHighlight.foreground4": "#79b8ff",
    "editorBracketHighlight.foreground5": "#ffab70",
    "editorBracketHighlight.foreground6": "#b392f0",
    "gitDecoration.addedResourceForeground": "#34d058",
    "gitDecoration.modifiedResourceForeground": "#79b8ff",
    "gitDecoration.deletedResourceForeground": "#ea4a5a",
    "gitDecoration.untrackedResourceForeground": "#34d058",
    "gitDecoration.ignoredResourceForeground": "#6a737d",
    "gitDecoration.conflictingResourceForeground": "#ffab70",
    "gitDecoration.submoduleResourceForeground": "#6a737d",
    "debugToolBar.background": "#2b3036",
    "editor.stackFrameHighlightBackground": "#C6902625",
    "editor.focusedStackFrameHighlightBackground": "#2b6a3033",
    "peekViewEditor.matchHighlightBackground": "#ffd33d33",
    "peekViewResult.matchHighlightBackground": "#ffd33d33",
    "peekViewEditor.background": "#1f242888",
    "peekViewResult.background": "#1f2428",
    "settings.headerForeground": "#e1e4e8",
    "settings.modifiedItemIndicator": "#0366d6",
    "welcomePage.buttonBackground": "#2f363d",
    "welcomePage.buttonHoverBackground": "#444d56"
  },
  "semanticHighlighting": true,
  "tokenColors": [
    {
      "scope": ["comment", "punctuation.definition.comment", "string.comment"],
      "settings": {
        "foreground": "#6a737d"
      }
    },
    {
      "scope": [
        "constant",
        "entity.name.constant",
        "variable.other.constant",
        "variable.other.enummember",
        "variable.language"
      ],
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": ["entity", "entity.name"],
      "settings": {
        "foreground": "#b392f0"
      }
    },
    {
      "scope": "variable.parameter.function",
      "settings": {
        "foreground": "#e1e4e8"
      }
    },
    {
      "scope": "entity.name.tag",
      "settings": {
        "foreground": "#85e89d"
      }
    },
    {
      "scope": "keyword",
      "settings": {
        "foreground": "#f97583"
      }
    },
    {
      "scope": ["storage", "storage.type"],
      "settings": {
        "foreground": "#f97583"
      }
    },
    {
      "scope": ["storage.modifier.package", "storage.modifier.import", "storage.type.java"],
      "settings": {
        "foreground": "#e1e4e8"
      }
    },
    {
      "scope": [
        "string",
        "punctuation.definition.string",
        "string punctuation.section.embedded source"
      ],
      "settings": {
        "foreground": "#9ecbff"
      }
    },
    {
      "scope": "support",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "meta.property-name",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "variable",
      "settings": {
        "foreground": "#ffab70"
      }
    },
    {
      "scope": "variable.other",
      "settings": {
        "foreground": "#e1e4e8"
      }
    },
    {
      "scope": "invalid.broken",
      "settings": {
        "fontStyle": "italic",
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": "invalid.deprecated",
      "settings": {
        "fontStyle": "italic",
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": "invalid.illegal",
      "settings": {
        "fontStyle": "italic",
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": "invalid.unimplemented",
      "settings": {
        "fontStyle": "italic",
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": "carriage-return",
      "settings": {
        "fontStyle": "italic underline",
        "background": "#f97583",
        "foreground": "#24292e",
        "content": "^M"
      }
    },
    {
      "scope": "message.error",
      "settings": {
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": "string variable",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": ["source.regexp", "string.regexp"],
      "settings": {
        "foreground": "#dbedff"
      }
    },
    {
      "scope": [
        "string.regexp.character-class",
        "string.regexp constant.character.escape",
        "string.regexp source.ruby.embedded",
        "string.regexp string.regexp.arbitrary-repitition"
      ],
      "settings": {
        "foreground": "#dbedff"
      }
    },
    {
      "scope": "string.regexp constant.character.escape",
      "settings": {
        "fontStyle": "bold",
        "foreground": "#85e89d"
      }
    },
    {
      "scope": "support.constant",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "support.variable",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "meta.module-reference",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "punctuation.definition.list.begin.markdown",
      "settings": {
        "foreground": "#ffab70"
      }
    },
    {
      "scope": ["markup.heading", "markup.heading entity.name"],
      "settings": {
        "fontStyle": "bold",
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "markup.quote",
      "settings": {
        "foreground": "#85e89d"
      }
    },
    {
      "scope": "markup.italic",
      "settings": {
        "fontStyle": "italic",
        "foreground": "#e1e4e8"
      }
    },
    {
      "scope": "markup.bold",
      "settings": {
        "fontStyle": "bold",
        "foreground": "#e1e4e8"
      }
    },
    {
      "scope": ["markup.underline"],
      "settings": {
        "fontStyle": "underline"
      }
    },
    {
      "scope": ["markup.strikethrough"],
      "settings": {
        "fontStyle": "strikethrough"
      }
    },
    {
      "scope": "markup.inline.raw",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": ["markup.deleted", "meta.diff.header.from-file", "punctuation.definition.deleted"],
      "settings": {
        "background": "#86181d",
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": ["markup.inserted", "meta.diff.header.to-file", "punctuation.definition.inserted"],
      "settings": {
        "background": "#144620",
        "foreground": "#85e89d"
      }
    },
    {
      "scope": ["markup.changed", "punctuation.definition.changed"],
      "settings": {
        "background": "#c24e00",
        "foreground": "#ffab70"
      }
    },
    {
      "scope": ["markup.ignored", "markup.untracked"],
      "settings": {
        "foreground": "#2f363d",
        "background": "#79b8ff"
      }
    },
    {
      "scope": "meta.diff.range",
      "settings": {
        "foreground": "#b392f0",
        "fontStyle": "bold"
      }
    },
    {
      "scope": "meta.diff.header",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "meta.separator",
      "settings": {
        "fontStyle": "bold",
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": "meta.output",
      "settings": {
        "foreground": "#79b8ff"
      }
    },
    {
      "scope": [
        "brackethighlighter.tag",
        "brackethighlighter.curly",
        "brackethighlighter.round",
        "brackethighlighter.square",
        "brackethighlighter.angle",
        "brackethighlighter.quote"
      ],
      "settings": {
        "foreground": "#d1d5da"
      }
    },
    {
      "scope": "brackethighlighter.unmatched",
      "settings": {
        "foreground": "#fdaeb7"
      }
    },
    {
      "scope": ["constant.other.reference.link", "string.other.link"],
      "settings": {
        "foreground": "#dbedff",
        "fontStyle": "underline"
      }
    }
  ]
}
